import React, { useState } from 'react';

function Develop() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  

  return (
    <section id="aboutus" className="dev-section">
      <h2 class="section-title">О нас</h2>
      <div className="hero-container">
        <div className="hero-content">
        <div className="hero-image-container">
            <img
              src="/images/logoenjoy.svg"
              alt="Enjoybymap"
              className="hero-image"
              width={300}
              height={300}
            />
          </div>
          <div className="hero-text">
            <div className="accordion">
              <p className='component-base'>  Мы - ENJOJBYMAP.  Наша команда состоит из высококвалифицированных специалистов, обладающих
                 глубокими знаниями и опытом в разработке и обработке пространственных данных. Мы объединяем разработчиков программного обеспечения, экспертов в области
                  ГИС (геоинформационных систем), аналитиков данных  и дизайнеров пользовательского интерфейса.</p>
            </div>
          </div>
          
          
        </div>
      </div>
    </section>
  );
}

export default Develop;

